module.exports = __webpack_public_path__ + "fonts/GT-America-Standard-Bold.271e67bc.woff2";